import { createAction, props } from '@ngrx/store';
import { IEmployeeBusinessDetailResponse } from '../models/employee-business-detail.model';

export const loadBiDetails = createAction('[BiDetails] Load BiDetails', props<{ businessId: string; employeeId: string }>());

export const loadBiDetailsSuccess = createAction(
  '[BiDetails] Load BiDetails Success',
  props<{ response: IEmployeeBusinessDetailResponse[] }>()
);

export const loadBiDetailsFailure = createAction('[BiDetails] Load BiDetails Failure', props<{ error: Error | any }>());
